import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import classNames from 'classnames';

import { setLastGood } from '../../Actions/app';
import { controlModalOrder } from '../../Actions/app';
import './ModalWindow.scss';
import success from '../../images/success.png';
import CurrentOrder from './CurrentOrder';
import LastGood from './LastGood';
import Button from '../../components/Button/Button';
import s from './ModalOrder.module.scss';
import { URL_API } from '../../config';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    border: 'none',
    backgroundColor: 'rgba(0,0,0,0)',
    padding: '10px',
    maxHeight: '100vh'
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.75)',
    zIndex: '1000'
  }
};

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#catalog');

const ModalOrder = props => {
  const {
    controlModal,
    showModalOrder,
    orderGoods,
    setLastGood_,
    lastGoodId,
    t
  } = props;

  if (!Array.isArray(orderGoods) || orderGoods.length < 1) return null;

  const closeModal = () => {
    setLastGood_(null);
    controlModal(false);
  };

  // const afterOpenModal = () => null

  const formОrder = () => {
    window.location = `${URL_API}/store`;
  };

  return (
    <Modal
      isOpen={showModalOrder}
      // onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className="modalContent">
        <header>
          <div className={classNames({ hide: !lastGoodId })}>
            <img src={success} alt="success" />
            <span className="">{t['Товар добавлен в корзину']}</span>
          </div>
          <div className={classNames({ hide: lastGoodId })}>
            <span className="">{t['Ваш заказ']}</span>
          </div>
          <div className="btn-close" onClick={closeModal}>
            ×
          </div>
        </header>
        <LastGood />
        <CurrentOrder />
        <div className="control">
          <div className={s.left} onClick={closeModal}>
            <Button
              btnStyle={{
                color: '#669900',
                hoverColor: '#568200',
                backgroundColor: '#fff',
                borderColor: '#669900',
                hoverBackgroundColor: '#fff',
                hoverBorderColor: '#568200'
              }}
              btnOptions={{
                size: 'small'
              }}
              text={t['Вернуться к списку товаров']}
            />
          </div>
          <div className={s.right} onClick={formОrder} data-inorder="true">
            <Button
              btnStyle={{
                color: '#fff',
                hoverColor: '#fff',
                backgroundColor: '#f17811',
                borderColor: '#f17811',
                hoverBackgroundColor: '#d5690e',
                hoverBorderColor: '#d5690e'
              }}
              btnOptions={{
                size: 'small'
              }}
              text={t['Оформить заказ']}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = state => ({
  orderGoods: state.currentOrder.order && state.currentOrder.order.goods,
  showModalOrder: state.app.showModalOrder,
  lastGoodId: state.app.lastGood,
  t: state.translation
});

const mapDispatchToProps = {
  controlModal: controlModalOrder,
  setLastGood_: setLastGood
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalOrder);
